import { ConstructionPhase } from '@/types';
import { request } from '@/utils/ajax';
import { createQueryHook } from '@/utils/hooks';

export function getConstructionPhases(projectId: number): Promise<ConstructionPhase[]> {
    return request(`api/project/${projectId}/construction-phases`).then((x) => x.json());
}

export const useConstructionPhases = createQueryHook(getConstructionPhases);
export interface ConstructionPhaseOption {
    name: string;
    id?: number;
}

export function updateConstructionPhases(projectId: number, constructionPhases: ConstructionPhaseOption[]) {
    return request(`api/construction-phase`, {
        method: 'POST',
        body: {
            projectId,
            constructionPhases,
        },
        json: true,
    });
}
